<ng-container *ngIf="page">

  <section class="contact-hero">
    <div class="container text-center">
      <h1 class="contact-hero__title display-3">{{ page.heroTitle }}</h1>
      <p class="contact-hero__subtitle mx-auto">{{ page.heroSubtitle }}</p>
    </div>
  </section>

  <section class="guidance py-5">
    <div class="container text-center position-relative">
      <app-background-icon
        src="/assets/images/icons/bandage.svg"
        [top]="15"
        [left]="20"
        [width]="250"
        [opacity]="0.5"
      />

      <h2 class="guidance__title display-4 mb-3">{{ page.guidanceTitle }}</h2>
      <p class="guidance__subtitle mx-auto mb-4">{{ page.guidanceSubtitle }}</p>
      <a [href]="page.guidanceLinkUrl" target="_blank" rel="noopener" class="guidance__cta btn ui-btn ui-btn--primary fw-bold">{{ page.guidanceLinkText }}</a>
    </div>
  </section>

  <section class="get-in-touch py-5">
    <div class="container">
      <h2 class="get-in-touch__title display-4 text-center mb-3">{{ page.getInTouchTitle }}</h2>
      <p class="get-in-touch__subtitle text-center mx-auto mb-5">{{ page.getInTouchSubtitle }}</p>

      <div class="row g-4">
        <div class="col-12 col-md-4" *ngFor="let card of page.cards">
          <app-icon-card [iconSrc]="card.iconSrc" [title]="card.title" [value]="card.value" [description]="card.description"></app-icon-card>
        </div>
      </div>
    </div>
  </section>

</ng-container>
